import { render, staticRenderFns } from "./Screenshots.vue?vue&type=template&id=04bd34b0&scoped=true"
import script from "./Screenshots.vue?vue&type=script&lang=js"
export * from "./Screenshots.vue?vue&type=script&lang=js"
import style0 from "./Screenshots.vue?vue&type=style&index=0&id=04bd34b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bd34b0",
  null
  
)

export default component.exports